import type { SVGProps } from 'react'
const SvgSyAdd = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M22.6,10.9h-9.5V1.4c0,0,0-.1,0-.2h-2c0,0,0,.1,0,.2v9.5H1.4c0,0-.1,0-.2,0v2c0,0,.1,0,.2,0h9.5v9.5c0,0,0,.1,0,.2h2c0,0,0-.1,0-.2v-9.5h9.5c0,0,.1,0,.2,0v-2c0,0-.1,0-.2,0Z" />
	</svg>
)
export default SvgSyAdd
